module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamonds@2x.beb35d1.jpg";